// Action Types
export const UPDATE_RG_CONFIG = "UPDATE_RG_CONFIG";

// Action Creator
export const updateRGConfig = (newConfig) => ({
    type: UPDATE_RG_CONFIG,
    newConfig,
});
